import type { CommentEntityType, Id } from "@estelle/domain";

/**
 * The cache keys a thread lives under.
 *
 * One place, so the thread on a record and anything else that reads it — the
 * order's timeline, which lists the same comments — share one fetch and cannot
 * disagree about what to refresh when a comment is posted.
 */
export const commentKeys = {
  thread: (entityType: CommentEntityType, entityId: Id) =>
    ["comments", entityType, entityId, "thread"] as const,
  people: (entityType: CommentEntityType, entityId: Id) =>
    ["comments", entityType, entityId, "people"] as const,
};
